// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"560":"pages/not-found","845":"pages/home"}[chunkId] || chunkId) + "." + {"483":"dee9312f","560":"ea584830","845":"bf34e9b0"}[chunkId] + ".chunk.js";
};